import { Component } from 'vue-property-decorator';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import { mixins } from 'vue-class-component';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import { DirectDebitFile } from '@accounting/interfaces/direct-debit-file';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';
import ExportDirectDebitFileModal from '@accounting/components/modals/export-direct-debit-file-modal/export-direct-debit-file-modal.vue';

@Component({
  name: 'bpc-direct-debit-file-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-page-title': BpcPageTitle,
    'bpc-entity-table': EntityTable,
    'bpc-std-filter': StdFilter,
    'bpc-std-form': StdForm,
    'bpc-drawer-modal': DrawerModal,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-export-direct-debit-file-modal': ExportDirectDebitFileModal,
  },
})
export default class DirectDebitFileTable extends mixins(AbstractTable) {
  declare $refs: AbstractTable['$refs'] & {
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };

  public entity: DirectDebitFile = null;
  public entityName = 'direct-debit-file';
  public pluralEntityName = 'direct-debit-files';
  public permissionEntityNameToUse = 'direct_debit_files';
  public formModel: DirectDebitFile = null;
  public showExportDirectDebitFileModal: boolean = false;
  public selectedRowEntity = null;

  public customRowActions = {
    softDelete: {
      activated: true,
      type: 'action',
      icon: 'trash',
      show: true,
      event: 'soft-delete',
      text: 'soft-delete',
      permissions: ['delete'],
    },
    directDebitFileExport: {
      activated: false,
      type: 'action',
      icon: 'file-invoice',
      show: false,
      event: 'export-direct-debit-file',
      text: 'export_direct_debit_file',
      permissions: ['download'],
    },
    directDebitFileExportXls: {
      activated: false,
      type: 'action',
      icon: 'file-excel',
      show: false,
      event: 'export-direct-debit-file-xls',
      text: 'export_direct_debit_file_xls',
      permissions: ['download'],
    },
  };

  extendUpdateRowActions(entity: any) {
    if (entity?.status) {
      if (entity.status === 'draft') {
        entity.actions.softDelete.show = true;
      } else {
        entity.actions.softDelete.show = false;
      }
    }
    entity.actions.directDebitFileExport.show = true;
    entity.actions.directDebitFileExportXls.show = true;
    return null;
  }

  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'export-direct-debit-file':
        this.onExportDirectDebitFile($event.item);
        break;
      case 'export-direct-debit-file-xls':
        this.onExportDirectDebitFileXls($event.item);
        break;
    }
  }

  onExportDirectDebitFile(item) {
    this.selectedRowEntity = item.item;
    this.showExportDirectDebitFileModal = true;
  }

  getUserOS(): string {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    let os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    return os;
  }

  onExportDirectDebitFileXls(item) {
    this.selectedRowEntity = item.item;
    const path = `${this.$bpcApiRouteHelper.getEntityPath('direct-debit-files')}/${
      this.selectedRowEntity.id
    }/exportXls`;

    const payload: AnyEntity = {
      os: this.getUserOS(),
    };

    this.$bpcApi.postDownload(path, '', payload).subscribe(
      () => {
        console.log('export');
      },
      error => {
        console.log(error);
      },
    );
  }

  onExportedDirectDebitFile() {
    this.$refs.provider.getEntities();
    this.onCloseExportDirectDebitFileModal();
  }

  onCloseExportDirectDebitFileModal() {
    this.showExportDirectDebitFileModal = false;
  }

  exportedDirectDebitFile() {
    //to be implemented
  }
}
